<script setup lang="ts">
import { FileLock2, MailQuestionMark } from 'lucide-vue-next';
import { Dialog } from 'primevue';
import { ref } from 'vue';

const props = defineProps<{
    supportEmailAddress: string;
}>();

const visible = ref(false);

const sections = [
    'privacyPolicy',
    'cookies',
    'security',
    'paymentOptions',
    'paymentTerms',
    'subscriptionAutoRenewal',
    'pricing',
    'refundPolicy',
    'cancellationPolicy',
    'dataFollowingCancellation',
    'contactUs'
];
</script>

<template>
    <Button
        class="w-full md:w-auto"
        :label="$t('privacyAndTerms.title')"
        severity="secondary"
        @click="visible = true"
        size="small"
        variant="text">
        <template #icon>
            <FileLock2 :size="16" />
        </template>
    </Button>
    <Dialog
        v-model:visible="visible"
        :dismissableMask="true"
        :draggable="false"
        :header="$t('privacyAndTerms.title')"
        modal
        class="w-[99%] lg:w-[90%] xl:w-[80%] 2xl:w-[70%] h-full lg:h-[90%] xl:h-[80%] 2xl:h-[70%]">
        <template #default>
            <div class="flex flex-col gap-5">
                <div v-for="key in sections" :key="key">
                    <p>
                        <strong>{{ $t('privacyAndTerms.sections.' + key + '.title') }}</strong>
                    </p>
                    <pre class="whitespace-pre-wrap mt-2">{{ $t('privacyAndTerms.sections.' + key + '.content') }}</pre>
                </div>
                <div class="flex justify-start">
                    <Button
                        v-if="!!props.supportEmailAddress"
                        as="a"
                        :href="
                            'mailto:' +
                            props.supportEmailAddress +
                            '?Subject=' +
                            encodeURI($t('xerScheduleToolkit') + ' - ' + $t('privacyAndTerms.title'))
                        "
                        :label="props.supportEmailAddress"
                        severity="secondary"
                        size="small"
                        variant="text">
                        <template #icon>
                            <MailQuestionMark :size="16" />
                        </template>
                    </Button>
                </div>
            </div>
        </template>
    </Dialog>
</template>
